// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InputMark_wrapper__37rRG","isBlue":"InputMark_isBlue__179A5"};